import { styled } from '@mui/system';

import { Box, Typography } from '@mui/material';

import { colors, fontFamilies } from '../../constants/theme';

export const NumberPillBox = styled(Box)(({ theme }) => ({
  borderRadius: '36px',
  backgroundColor: colors.iconBackground,
  width: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: fontFamilies.gotham,
  flex: 1,
  alignSelf: 'stretch',
  minHeight: '76px',

  [theme.breakpoints.down('xl')]: {
    minHeight: '68px',
    borderRadius: '32px',
  },

  [theme.breakpoints.down('lg')]: {
    minHeight: '60px',
    borderRadius: '28px',
  },

  [theme.breakpoints.down('md')]: {
    minHeight: '52px',
    borderRadius: '24px',
  },

  [theme.breakpoints.down('sm')]: {
    minHeight: '44px',
    borderRadius: '20px',
  },

  [theme.breakpoints.down(500)]: {
    minHeight: '36px',
    borderRadius: '16px',
  },
}));

export const NumberText = styled(Typography)(({ theme }) => ({
  fontWeight: 300,
  fontSize: '32px',
  height: 'auto',
  fontFamily: fontFamilies.gotham,

  [theme.breakpoints.down('xl')]: {
    fontSize: '28px',
  },

  [theme.breakpoints.down('lg')]: {
    fontSize: '24px',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },

  [theme.breakpoints.down(500)]: {
    fontSize: '14px',
  },
}));
